import CryptoJS from 'crypto-js'

/**
 * Encrypts the given text using AES 256 CBC encryption.
 *
 * @param {string} text - The text to be encrypted.
 * @param {string} key - The encryption key.
 * @param {string} iv - The initialization vector.
 * @returns {string} The encrypted text.
 */
export const encryptAES = (text, key, iv) => {
    return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding,
    }).toString()
}

export const decryptAES = (ciphertext, key, iv) => {
    const bytes = CryptoJS.AES.decrypt(
        ciphertext,
        CryptoJS.enc.Utf8.parse(key),
        {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    )
    return bytes.toString(CryptoJS.enc.Utf8)
}
